import React, { useEffect, useState } from 'react'
import { Close } from '@mui/icons-material'
import { ApiService } from '../ApiService';
import { countries, returnCurrentDate, ModalForAll } from '../../components'
import { toast } from 'react-toastify';
import Select, { components } from 'react-select';
import EmailIcon from '@mui/icons-material/Email';
import EmailRegisterIcon from '../../svg/EmailRegisterIcon';
import LockIcon from '../../svg/LockIcon';
import PersonCardIcon from '../../svg/PersonCardIcon.js';
import PhoneIcon from '../../svg/PhoneIcon.js';
import CalendarIcon from '../../svg/CalendarIcon.js';
import MessageIcon from '../../svg/MessageIcon.js';
import WhatsappIcon from '../../svg/WhatsappIcon.js';
import CorreoIcon from '../../svg/CorreoIcon.js';
import GeneroIcon from '../../svg/GeneroIcon.js';
import { openDB } from 'idb';

const API_URL = process.env.REACT_APP_API_URL;
const customStyles = {
    control: (base, state) => ({
        ...base,
        backgroundColor: '#fff', // Fondo transparente
        border: 'none',                 // Sin borde
        boxShadow: 'none',              // Sin sombra al enfocar
        borderRadius: '15px',
        '&:hover': {
            border: 'none',
        },
        color: '#000',
        fontSize: '16px',
        minWidth: '130px',
        width: 'fit-content',
        cursor: 'text',
    }),
    dropdownIndicator: (base) => ({
        ...base,
        color: '#333', // Cambia el color del ícono si quieres
        cursor: 'pointer',
    }),
    indicatorSeparator: () => ({
        display: 'none', // Oculta la línea entre el input y el ícono
    }),
    menu: (base) => ({
        ...base,
        backgroundColor: 'white', // Fondo del menú desplegable
        border: '1px solid #ccc',
        color: '#000',
        fontSize: '16px',
    }),
};

const optionsSelect = countries.map((obj) => ({
    value: obj.dialCode,
    label: obj.name,
    name: obj.nameCode,
    image: `/banderas/${obj.nameCode}.png`
}));

export function ModalLogin({ stateModal = false, handleModal = (() => { }) }) {
    const [user, setUser] = useState("");
    const [pass, setPass] = useState("");

    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [genderSelected, setGenderSelected] = useState(null);
    const [phoneCode, setPhonCode] = useState(null);
    const [phone, setPhone] = useState(null);
    const [birthay, setBirthay] = useState(returnCurrentDate());
    const [modeVerificacion, setModeVerificacion] = useState("email");
    const [codeVerifiction, setCodeVerification] = useState([]);

    const [changeModal, setChangeModal] = useState("login");
    const [steteRequest, setStateRequest] = useState(false);

    const CustomOption = (props) => (
        <components.Option {...props}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <img
                    src={props.data.image}
                    alt={props.data.label}
                    style={{ width: 25, marginRight: 5 }}
                    key={props.data.label}
                />
                {props.data.label}({String(props.data.name).toUpperCase()})
            </div>
        </components.Option>
    );

    const CustomSingleValue = (props) => (
        <components.SingleValue {...props}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
                <img
                    src={props.data.image}
                    alt={props.data.label}
                    style={{ width: 25, marginRight: 5 }}
                />
                {props.data.label}({String(props.data.name).toUpperCase()})
            </div>
        </components.SingleValue>
    );

    async function LogIn(event) {
        event.preventDefault();
        const userData = {
            email_User: String(user).toLowerCase(),
            origin: window.origin ?? 'https://hosming.com',
            password: String(pass),
            password_confirmation: String(pass),
        };

        if (userData.email_User.length <= 0 || userData.email_User.length < 7) return toast.info("Email debe contener al menos 7 letras");
        if (userData.email_User.length > 50) return toast.info("Email debe contener un maximo de 50 letras");
        if (!(/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(userData.email_User))) return toast.warning("Email ingresado es invalido");

        if (userData.password_confirmation.length <= 0 || userData.password_confirmation.length < 8) return toast.info("Contraseña debe contener al menos 7 letras");
        if (userData.password_confirmation.length > 30) return toast.info("Contraseña debe contener un maximo de 30 letras");


        try {
            setStateRequest(true);
            const senLog = await fetch(API_URL + 'api/auth/login', {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(userData),
            });

            const response_log = await senLog.json();

            if (!senLog.ok) {
                if (response_log?.message == "Verificar") await senCodeUser();
                else toast.error(response_log?.message ?? "Error, vuelve a intentarlo luego");
            } else {
                let tempDataDB = await openDB('data-storage', 3, {
                    upgrade(db) {
                        if (!db.objectStoreNames.contains('companies')) db.createObjectStore('companies', { keyPath: 'id' });
                        if (!db.objectStoreNames.contains('expiration')) db.createObjectStore('expiration', { keyPath: 'id' });
                        if (!db.objectStoreNames.contains('gallery')) db.createObjectStore('gallery', { keyPath: 'id' });
                        if (!db.objectStoreNames.contains('posts')) db.createObjectStore('posts', { keyPath: 'id' });
                        if (!db.objectStoreNames.contains('general')) db.createObjectStore('general', { keyPath: 'id' });
                        if (!db.objectStoreNames.contains('validTokens')) db.createObjectStore('validTokens', { keyPath: 'id' });
                    },
                });

                await tempDataDB.clear("companies");
                await tempDataDB.clear("expiration");
                await tempDataDB.clear("gallery");
                await tempDataDB.clear("posts");
                await tempDataDB.clear("general");
                sessionStorage.clear();
                tempDataDB = null;

                localStorage.setItem("token", response_log.access_token);
                handleModal(false);
                setUser("");
                setPass("");
            }
        } catch (err) {
            toast.error(err?.message ?? "Solicitud fallida, contactece con soporte");
        } finally {
            setStateRequest(false);
        }
    }


    useEffect(() => {
        setBirthay(returnCurrentDate());
    }, []);

    function esMayorDeEdad() {
        const fechaNacimiento = new Date(birthay);

        if (isNaN(fechaNacimiento.getTime())) {
            return { valido: false, mensaje: "Fecha no válida" };
        }
        const hoy = new Date();
        const fecha18Anios = new Date(hoy.getFullYear() - 18, hoy.getMonth(), hoy.getDate());
        const esMayor = fechaNacimiento <= fecha18Anios;

        return esMayor ? false : true;
    }

    async function senCodeUser() {
        if (!steteRequest) setStateRequest(true);

        var body_fetch = {};

        if (changeModal == "login" || modeVerificacion == 'email') body_fetch.email_User = user;
        else body_fetch.full_phone = phoneCode.value + phone;

        try {
            const verifyAccount_fetch = await fetch(API_URL + 'api/auth/sendCode', {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(body_fetch),
            });

            if (verifyAccount_fetch.ok) setChangeModal("verification");
            else {
                const getMessage = await verifyAccount_fetch.json();
                toast.error(getMessage?.message ?? "Verificación fallida. Intenta nuevamente o contacta soporte");
                if (getMessage?.code == 401) setChangeModal("verification");
            }
        } catch (err) {
            console.error("Error solicitud:", err);
        } finally {
            setStateRequest(false);
        }
    }

    async function registerUser(event) {
        event.preventDefault();

        if (firstName.length < 2) return toast.warning("Nombre debe contener al menos 2 letras");
        if (firstName.length > 30) return toast.warning("Nombre debe contener maximo 30 letras");

        if (lastName.length < 2) return toast.warning("Apellido debe contener al menos 2 letras");
        if (lastName.length > 30) return toast.warning("Apellido debe contener maximo 30 letras");

        if (!phoneCode?.value) return toast.warning("Selecciona tu codigo de pais");
        if (String(phone).length < 6 || String(phone).length > 15) return toast.info("Ingresa un número de celular válido");
        if (!genderSelected?.value) return toast.warning("Selecciona tu genero");

        const userData = {
            email_User: String(user).toLowerCase(),
            password: String(pass),
            password_confirmation: String(pass),
        };

        if (userData.email_User.length <= 0 || userData.email_User.length < 7) return toast.info("Email debe contener al menos 7 letras");
        if (userData.email_User.length > 50) return toast.info("Email debe contener un maximo de 50 letras");
        if (!(/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(userData.email_User))) return toast.warning("Email ingresado es invalido");

        if (userData.password_confirmation.length <= 0 || userData.password_confirmation.length < 8) return toast.info("Contraseña debe contener al menos 7 letras");
        if (userData.password_confirmation.length > 30) return toast.info("Contraseña debe contener un maximo de 30 letras");

        if (esMayorDeEdad()) return toast.warning("Nacimiento no válido (mínimo 18 años)");

        if (modeVerificacion == "") return toast.info("Selecciona un metodo de verificación");

        const body_fetch = {
            firstName: firstName,
            lastName: lastName,
            birth: birthay,
            codePhone: phoneCode.value,
            codeText: phoneCode.name,
            phone: phone,
            emailUser: user,
            password: pass,
            password_confirmation: pass,
            gender: genderSelected.value
        }

        try {
            setStateRequest(true);
            const register_fetch = await fetch(API_URL + 'api/auth/register', {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(body_fetch),
            });

            const response_reg = await register_fetch.json();

            if (!register_fetch.ok) {
                toast.error(response_reg?.message ?? "Error, vuelve a intentarlo luego");
            } else {
                await senCodeUser();
            }
        } catch (err) {
            toast.error(err?.message ?? "Solicitud fallida, contactece con soporte");
        } finally {
            setStateRequest(false);
        }
    }

    const styleIcons = {
        height: '35px',
        width: '42px',
        padding: '3px',
        backgroundColor: '#fff',
        borderRadius: '10px'
    };

    const textoVerification = {
        sms: 's mensajes',
        whatsapp: ' cuenta de Whatsapp',
        email: ' cuenta de Gmail / Email',
    };

    async function verifyAccount(event) {
        event.preventDefault();

        var codeReceived = "";
        codeVerifiction.forEach((text) => codeReceived = codeReceived + text);

        if (codeReceived.length < 6) return toast.warning("El código de verificación debe tener 6 números");
        if (!steteRequest) setStateRequest(true);

        var body_request = { code: codeReceived };
        if (changeModal == "login" || modeVerificacion == 'email') body_request.email_User = user;
        else body_request.full_phone = phoneCode.value + phone;

        try {
            const verification_fetch = await fetch(API_URL + 'api/auth/verifyCode', {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(body_request),
            });

            if (verification_fetch.ok) {
                toast.success("Verificado exitosamente", {
                    autoClose: 2000,
                    closeButton: false
                });

                setChangeModal("login");
            } else {
                const getMessage = await verification_fetch.json();
                toast.error(getMessage?.message ?? "No se pudo verificar tu cuenta. Contacta a soporte");
            }

        } catch (err) {
            console.error("Error solicitud:", err);
        } finally {
            setStateRequest(false);
        }
    }

    function setValueInputs(event, position) {
        if (event.key) {
            if (position > 0 && event.key == "ArrowLeft") document.getElementById("codeverification_" + (position - 1)).focus();
            if (position < 5 && event.key == "ArrowRight") document.getElementById("codeverification_" + (position + 1)).focus();

            if (position > 0 && event.key == "Backspace") {
                if (event.target.value == "") {
                    document.getElementById("codeverification_" + (position - 1)).focus();
                    setCodeVerification((current_val) => {
                        const val_reset = [...current_val];
                        val_reset[position - 1] = "";
                        return val_reset;
                    });
                }
            }
            return;
        }

        if (event?.clipboardData || window?.clipboardData) {
            const getText = String((event.clipboardData || window.clipboardData).getData('text'));

            if (getText.length > 0 && getText.length <= 6) {
                setCodeVerification(current_val => {
                    const reset_values = [...current_val];
                    var contador = 0;
                    for (let i = position; i < 6; i++) {
                        const getNumber = getText.substring(contador, (contador + 1));
                        if (!getNumber) break;
                        reset_values[i] = /^\d*$/.test(getNumber) ? getNumber : (reset_values[i] ?? "");
                        contador++;
                    }

                    return reset_values;
                });
            } else toast.error("Solo puedes ingresar 6 números o menos");
            return;
        }

        setCodeVerification(current_val => {
            const val_reset = [...current_val];
            const valt_text = event.target.value;
            const permitido = /^\d*$/.test(valt_text) && Number(valt_text) <= 9 ? true : false;

            val_reset[position] = permitido ? valt_text : val_reset[position];

            if (permitido && position < 5) document.getElementById("codeverification_" + (position + 1)).focus();

            return val_reset;
        });
    }

    return (
        <ModalForAll className='modal-login shadow-lvl6' stateModal={stateModal} setStateModal={handleModal}>
            <button className='default-buttons close-modal' onClick={() => handleModal(false)}><Close /></button>
            <ul>
                <li className={'containir-login ' + (changeModal == "login" ? 'current-modal' : 'disable-modal')}>
                    <h2>Iniciar Sesion</h2>

                    <form action='/'>
                        <label>
                            <span><EmailRegisterIcon main_css={styleIcons} />Correo</span>
                            <input type='text' name='logEmail' placeholder='email.prueba@gmail.com' value={user} onChange={(event) => setUser(event.target.value)} />
                        </label>

                        <label>
                            <span><LockIcon main_css={styleIcons} />Contraseña</span>

                            <input type='password' name='logPass' placeholder='****************' value={pass} onChange={(event) => setPass(event.target.value)} style={{ textAlign: 'center' }} autoComplete='off' />
                        </label>

                        <input
                            type='submit'
                            className='default-buttons'
                            value={steteRequest ? 'Ingresando...' : 'Ingresar a hosming'}
                            style={{ backgroundColor: (`rgba(var(--value-theme-main),${steteRequest ? '0.5' : '1'})`) }}
                            onClick={(event) => LogIn(event)}
                            disabled={steteRequest}
                        />
                    </form>

                    <button className='default-buttons' style={{ width: '100%', color: 'var(--theme-main)', fontSize: '16px' }} onClick={() => setChangeModal("register")}>Crear una cuenta nueva...</button>
                </li>

                <li className={'containir-register ' + (changeModal == "register" ? 'current-modal' : 'disable-modal')}>
                    <h2>Crear Usuario</h2>

                    <form action='/'>
                        <div className='rows-2'>
                            <label >
                                <span><PersonCardIcon main_css={styleIcons} />Nombre</span>
                                <input type='text' name='firstName' placeholder='Ingresa tu nombre aquí...' value={firstName} onChange={(event) => setFirstName(event.target.value)} />
                            </label>

                            <label>
                                <span><PersonCardIcon main_css={styleIcons} />Apellido</span>
                                <input type='text' name='lastname' placeholder='Ingresa tu apellido aquí...' value={lastName} onChange={(event) => setLastName(event.target.value)} />
                            </label>
                        </div>

                        <div className='rows-3'>
                            <label>
                                <span><PhoneIcon main_css={styleIcons} />Nro. Celular</span>

                                <span>
                                    <div style={{ width: '140px' }}>
                                        <Select
                                            options={optionsSelect}
                                            value={phoneCode}
                                            onChange={setPhonCode}
                                            components={{ Option: CustomOption, SingleValue: CustomSingleValue }}
                                            placeholder='BO +591'
                                            styles={customStyles}
                                        />
                                    </div>
                                    <input type='text' value={phone} onChange={(event) => setPhone((current_text) => /^\d*$/.test(event.target.value) ? event.target.value : current_text)} placeholder='Numero de teléfono' />
                                </span>
                            </label>

                            <label>
                                <span><GeneroIcon main_css={styleIcons} />Genero</span>

                                <Select
                                    options={[
                                        { label: 'Masculino', value: 'M' },
                                        { label: 'Femenino', value: 'F' },
                                        { label: 'Otro', value: 'O' },
                                    ]}
                                    value={genderSelected}
                                    onChange={setGenderSelected}
                                    placeholder='Masculino?'
                                    styles={customStyles}
                                />
                            </label>
                        </div>

                        <div className='rows-2'>
                            <label >
                                <span><EmailRegisterIcon main_css={styleIcons} />Correo</span>
                                <input type='text' name='email' placeholder='email.prueba@gmail.com' value={user} onChange={(event) => setUser(event.target.value)} />
                            </label>

                            <label>
                                <span><LockIcon main_css={styleIcons} />Contraseña</span>
                                <input type='password' name='logPass' placeholder='****************' value={pass} onChange={(event) => setPass(event.target.value)} style={{ textAlign: 'center' }} autoComplete='off' />
                            </label>
                        </div>

                        <div className='rows-2'>
                            <label >
                                <span><CalendarIcon main_css={styleIcons} />Fecha de Nacimiento</span>
                                <input type='date' name='birthay' value={birthay} onChange={(event) => setBirthay(event.target.value)} />
                            </label>

                            <label htmlFor=''>Metodo de verificación
                                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-around', gap: '15px' }}>
                                    {/* <span onClick={(event) => { event.preventDefault(); setModeVerificacion("sms") }} style={{ cursor: 'pointer' }}><MessageIcon main_css={{ ...styleIcons, transform: modeVerificacion == 'sms' ? 'scale(1.2)' : 'scale(1)' }} /></span> */}
                                    <span onClick={(event) => { event.preventDefault(); setModeVerificacion("whatsapp") }} style={{ cursor: 'pointer' }}><WhatsappIcon main_css={{ ...styleIcons, transform: modeVerificacion == 'whatsapp' ? 'scale(1.2)' : 'scale(1)' }} /></span>
                                    <span onClick={(event) => { event.preventDefault(); setModeVerificacion("email") }} style={{ cursor: 'pointer' }}><CorreoIcon main_css={{
                                        ...styleIcons,
                                        padding: '4px 6px',
                                        transform: modeVerificacion == 'email' ? 'scale(1.2)' : 'scale(1)'
                                    }} /></span>
                                </div>
                            </label>
                        </div>

                        <input
                            type='submit'
                            className='default-buttons'
                            value={steteRequest ? 'Registrando...' : 'Registrar Usuario'}
                            style={{ backgroundColor: (`rgba(var(--value-theme-main),${steteRequest ? '0.5' : '1'})`), color: 'var(--empresa-color)', fontWeight: '550', marginTop: '20px' }}
                            onClick={(event) => registerUser(event)}
                            disabled={steteRequest}
                        />
                    </form>

                    <button className='default-buttons' style={{ width: '100%', color: 'var(--theme-main)', fontSize: '16px' }} onClick={() => setChangeModal("login")}>Ya tengo una cuenta</button>
                </li>

                <li className={'containir-verification ' + (changeModal == "verification" ? 'current-modal' : 'disable-modal')}>
                    <h2>Verificacion de Usuario</h2>

                    <form action='/' style={{ gap: '20px' }}>
                        <p style={{ maxWidth: '570px', textAlign: 'center' }}>Registro exitoso. Ahora solo debes ingresar a tu{textoVerification[modeVerificacion] ?? " cuenta de Gmail / Email"}, copiar el código de verificación que te enviamos y colocarlo aquí para verificar tu cuenta.</p>

                        <div style={{ display: 'flex', width: '100%', justifyContent: 'center', gap: '15px' }}>
                            {
                                Array.from({ length: 6 }).map((val, index) => (
                                    <input
                                        key={'textCode_' + index}
                                        name={'textCode_' + index}
                                        id={'codeverification_' + index}
                                        type='text'
                                        value={codeVerifiction[index] ?? ""}
                                        onChange={(event) => setValueInputs(event, index)}
                                        onKeyDown={(event) => setValueInputs(event, index)}
                                        onPaste={(event) => setValueInputs(event, index)}
                                        style={{ width: '50px', height: '50px', fontSize: '20px', padding: '5px', textAlign: 'center' }}
                                        placeholder='0'
                                    />
                                ))
                            }
                        </div>
                        <input
                            type='submit'
                            className='default-buttons'
                            value={steteRequest ? 'Enviando verificación...' : 'Verificar Cuenta!'}
                            style={{ backgroundColor: (`rgba(var(--value-theme-main),${steteRequest ? '0.5' : '1'})`), color: 'var(--empresa-color)', fontWeight: '550', marginTop: '20px' }}
                            onClick={(event) => verifyAccount(event)}
                            disabled={steteRequest}
                        />
                    </form>

                </li>
            </ul>
        </ModalForAll>
    )
}
